exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb-3[data-v-796f7c76] {\n  margin-bottom: 12px;\n}\n", ""]);

// exports
